import PhotoSwipeLightbox from "photoswipe/lightbox"
import "photoswipe/style.css"

// Initialize PhotoSwipe lightbox
const initGallery = () => {
  const galleryElement = document.getElementById("photo-gallery")
  if (!galleryElement) return

  const lightbox = new PhotoSwipeLightbox({
    gallery: "#photo-gallery",
    children: "a",
    pswpModule: () => import("photoswipe"),
  })

  lightbox.init()
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGallery)
} else {
  initGallery()
}
